import React              from 'react';
import currentEditorStore from '@/TokamapEditor/stores/currentEditorStore';

/** Tant que `active`, affiche les formes de la sidebar dans leur état de survol sur la carte. */
export default function useHoverPreview(active: boolean) {
	const key = currentEditorStore.sidebarShapes.map(shape => shape.id).join('|');

	React.useEffect(() => {
		if (!active || !key) return;

		const adapter = currentEditorStore.get.mapAdapter;

		adapter.setHoverPreviewShapes(key.split('|'));

		return () => adapter.setHoverPreviewShapes([]);
	}, [active, key]);
}
